module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "tag": "div",
      "css": false,
      "name": "fade-up"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fe18ffb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListTransition.vue
// module id = 454
// module chunks = 2